var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', {
    staticClass: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [(_vm.showAddModuleFlag == false) ? _c('div', [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('a', {
    staticClass: "btn-setting d-sm-down-none",
    attrs: {
      "title": "Add"
    },
    on: {
      "click": _vm.showAddModuleForm
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])])]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Module Name ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-search'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.moduleServiceName),
      expression: "moduleServiceName"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "name": "moduleServiceName",
      "id": "moduleServiceName",
      "placeholder": "Enter Module Services Name"
    },
    domProps: {
      "value": (_vm.moduleServiceName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.moduleServiceName = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('b-input-group', [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.searchModuleMaster
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("   \n                      "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.clear
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])], 1)])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading2
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading2 = $event
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.showAddModuleFlag == true) ? _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    slot: "header"
  }, [(_vm.action == 'add') ? _c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Add Module Master")]) : _vm._e(), _vm._v(" "), (_vm.action == 'update') ? _c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Update Module Master")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "float": "right",
      "cursor": "pointer",
      "margin-right": "7px"
    },
    attrs: {
      "title": "Back"
    },
    on: {
      "click": _vm.hideAddReasonForm
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body1",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('b-card', [_c('fieldset', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading2
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading2 = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "from-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [(_vm.action == 'add') ? _c('b-form-fieldset', [_c('label', [_vm._v("Module Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-briefcase'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.modulename),
      expression: "modulename"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('modulename')
    },
    attrs: {
      "id": "modulename",
      "name": "modulename"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.modulename = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.checkAvaibiltityOfModule]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Model ")]), _vm._v(" "), _vm._l((_vm.moduleList), function(moduleitem) {
    return _c('option', {
      domProps: {
        "value": moduleitem.modulemasterid
      }
    }, [_vm._v(_vm._s(moduleitem.modulename))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('modulename')),
      expression: "errors.has('modulename')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Module Name.")])], 1) : _vm._e(), _vm._v(" "), (_vm.action == 'update') ? _c('b-form-fieldset', [_c('label', [_vm._v("Module Name")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-briefcase'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.modulename),
      expression: "modulename"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('modulename')
    },
    attrs: {
      "id": "modulename",
      "name": "modulename",
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.modulename = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("Select Model ")]), _vm._v(" "), _vm._l((_vm.moduleList), function(moduleitem) {
    return _c('option', {
      domProps: {
        "value": moduleitem.modulemasterid
      }
    }, [_vm._v(_vm._s(moduleitem.modulename))])
  })], 2)]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('modulename')),
      expression: "errors.has('modulename')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Module Name.")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Select Module Level")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-users'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.moduleLevel),
      expression: "moduleLevel"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true,
      'error': _vm.errors.has('moduleLevel')
    },
    attrs: {
      "id": "moduleLevel",
      "name": "moduleLevel"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.moduleLevel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.addArray()
      }]
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("--Select Module Level--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Level 1")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Level 2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("Level 3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Level 4")])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('moduleLevel')),
      expression: "errors.has('moduleLevel')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Module Level.")])], 1)], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "from-group row"
  }, [(_vm.userRoleFlag == true) ? _c('div', {
    staticClass: "col-4"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "581px"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "120px"
    }
  }, [_c('b', [_vm._v("User Email")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "80px"
    }
  }, [_c('b', [_vm._v("Approval Level")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.userRolearr), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_c('b-input-group', [_c('b-form-input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }],
      staticClass: "form-control",
      class: {
        'form-control': true,
        'error': _vm.errors.has("'email-'+index")
      },
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "id": 'email-' + index,
        "name": 'email-' + index,
        "type": "text",
        "placeholder": "Enter Email"
      },
      on: {
        "input": _vm.chkRowsfoEmail
      },
      model: {
        value: (val.email),
        callback: function($$v) {
          val.email = $$v
        },
        expression: "val.email"
      }
    }), _vm._v(" "), _c('span', [_vm._v("@xpressbees.com")])], 1), _vm._v(" "), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(val.emailerror))])], 1), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (val.userrole),
        expression: "val.userrole"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": ""
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          val.userrole = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "selected": "",
        "value": "",
        "disabled": ""
      }
    }, [_vm._v("--Select Module Level--")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "1"
      }
    }, [_vm._v("Level 1")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "2"
      }
    }, [_vm._v("Level 2")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "3"
      }
    }, [_vm._v("Level 3")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "4"
      }
    }, [_vm._v("Level 4")])])])])
  }))]), _c('br')]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "creategroupfooter form-actions pull-left"
  }, [(_vm.action == 'add') ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Create")]) : _vm._e(), _vm._v("  \n                    "), (_vm.action == 'update') ? _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Update")]) : _vm._e(), _vm._v("  \n                    "), _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearAddModuleForm
    }
  }, [_vm._v("Clear")])])], 1)])], 1)])]) : _vm._e()])]), _vm._v(" "), (_vm.validListFlag == true) ? _c('div', {
    staticClass: "col-12"
  }, [_vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [(_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "6",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.modulelist), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(val.modulemasterid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(val.modulename))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "text-center link",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getUserrolelistByModuleMasterId(val.modulemasterid)
        }
      }
    }, [_vm._v(_vm._s(val.moduleapprovallevel))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center link",
      on: {
        "click": function($event) {
          _vm.openUpdateModule(val.modulemasterid)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-pencil"
    })])])
  })], 2)]), _c('br'), _vm._v(" "), _c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 5,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  }), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Approval Level"
    },
    on: {
      "click": function($event) {
        _vm.ModuleApprovalLevel = false
      }
    },
    model: {
      value: (_vm.ModuleApprovalLevel),
      callback: function($$v) {
        _vm.ModuleApprovalLevel = $$v
      },
      expression: "ModuleApprovalLevel"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("Approval Level")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeStatusModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Role Sequence")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Email ID")])])])]), _vm._v(" "), _c('tbody', [(_vm.resultUserCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.UserRolelist), function(val, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(val.userrole))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(val.email))])])
  })], 2)]), _c('br')])])]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading1
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading1 = $event
      }
    }
  })], 1)], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Module Master List")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("#")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Module ID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Module Name")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Module Approval Level")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Action")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e294278","hasScoped":true}!./src/views/components/cargoclient/approvalflow/approvalflow-tab/module/module.component.html
// module id = 549
// module chunks = 3